import { render, staticRenderFns } from "./CourseInstitute.vue?vue&type=template&id=08a9cf0e&scoped=true&"
import script from "./CourseInstitute.vue?vue&type=script&lang=js&"
export * from "./CourseInstitute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a9cf0e",
  null
  
)

export default component.exports